
import { Component, Vue } from 'vue-property-decorator'
import { getCaneSnapshotsBySerial, listCaneSnapshots, getCaneSnapshotDetail } from '@/api/diagnostics'

@Component({ name: 'Diagnostics' })
export default class extends Vue {
  private list: any[] = []
  private total = 0
  private loading = false
  private page = 1
  private pageSize = 50

  private filter: any = { serial: '', source: '', dateRange: [], groupByCane: true }

  // Grouped view is active only when grouping is on AND no single serial is
  // being drilled into (a serial filter switches to that cane's time-series).
  private get isGrouped(): boolean {
    return !!this.filter.groupByCane && !this.filter.serial.trim()
  }

  private detailVisible = false
  private detail: any = null
  private detailTitle = ''

  created() {
    this.fetch()
  }

  private params() {
    const p: any = { limit: this.pageSize, offset: (this.page - 1) * this.pageSize }
    if (this.filter.source) p.source = this.filter.source
    if (this.filter.dateRange && this.filter.dateRange.length === 2) {
      p.from = this.filter.dateRange[0]
      p.to = this.filter.dateRange[1] + 'T23:59:59'
    }
    if (this.isGrouped) p.groupByCane = true
    return p
  }

  // Drill into one cane's snapshot history from the grouped list.
  private viewCaneSnapshots(row: any) {
    this.filter.serial = row.caneSerialNumber
    this.filter.groupByCane = false
    this.page = 1
    this.fetch()
  }

  private async fetch() {
    this.loading = true
    try {
      const serial = this.filter.serial.trim()
      const res = serial
        ? await getCaneSnapshotsBySerial(serial, this.params())
        : await listCaneSnapshots(this.params())
      this.list = res.data?.data?.items || []
      this.total = res.data?.data?.total || 0
    } catch (err: any) {
      this.$message.error(err.response?.data?.status?.message || this.$t('diagnostics.loadFailed') as string)
      this.list = []
      this.total = 0
    } finally {
      this.loading = false
    }
  }

  private onSearch() { this.page = 1; this.fetch() }
  private resetFilter() { this.filter = { serial: '', source: '', dateRange: [], groupByCane: true }; this.page = 1; this.fetch() }
  private onPageChange(p: number) { this.page = p; this.fetch() }
  private onSizeChange(s: number) { this.pageSize = s; this.page = 1; this.fetch() }

  private async openDetail(row: any) {
    this.detailTitle = `Snapshot - ${row.caneSerialNumber}`
    this.detailVisible = true
    this.detail = null
    try {
      const res = await getCaneSnapshotDetail(row.id)
      this.detail = res.data?.data || row
    } catch {
      this.detail = row // en azından listedeki veriyi göster
    }
  }

  // --- yardımcılar ---
  private s(): any { return this.detail?.snapshot || {} }
  private bat(row: any): any { return row?.snapshot?.battery || null }
  private uptime(row: any): string {
    const ms = row?.snapshot?.firmware?.systemUptimeMs
    if (!ms && ms !== 0) return '-'
    const sec = Math.floor(ms / 1000)
    const h = Math.floor(sec / 3600); const m = Math.floor((sec % 3600) / 60)
    return h > 0
      ? this.$t('diagnostics.uptimeHours', { h, m }) as string
      : this.$t('diagnostics.uptimeMinutes', { m, s: sec % 60 }) as string
  }

  private isFault(hex: any): boolean { return !!hex && /[1-9a-fA-F]/.test(String(hex)) }
  private faultCount(row: any): number {
    const f = row?.snapshot?.faults || {}
    return Object.values(f).filter((v: any) => this.isFault(v)).length
  }

  private fmtTime(v: string): string {
    if (!v) return '-'
    const d = new Date(v)
    return isNaN(d.getTime()) ? String(v) : d.toLocaleString('tr-TR')
  }
}
